import { UserType } from './enum.model';

export class AccountInfo {
  email: string;
  firstName: string;
  lastName: string;
  userType: UserType;
  categories: string[];
}
